<template>
  <div class="ssh-key">
    <div class="view-title">SSH KEY</div>
    <div class="content">
      <div class="add-ssk">
        <a href="javascript:;" @click.stop="onShowAdd()">
          <i class="el-icon-plus"></i>
          <translate>Add</translate>
        </a>
      </div>
      <el-table v-loading="loading" :data="sshKeyList" style="width: 100%" :row-class-name="tableRowClassName">
        <el-table-column :label="attrText.name" prop="title"></el-table-column>
        <el-table-column :label="attrText.latestVerifiTiem">
          <template scope="scope">
            <div class="log-list-name">
              <p>{{!scope.row.last_time ? '-' : scope.row.last_time * 1000 | moment("YYYY-MM-DD HH:mm:ss")}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="attrText.addTime">
          <template scope="scope">
            <div class="log-list-name">
              <p>{{scope.row.create_time * 1000 | moment("YYYY-MM-DD HH:mm:ss")}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="attrText.action" width="100">
          <template scope="scope">
            <el-button type="text" @click="delSshkey(scope.row.id)">
              <translate>Delete</translate>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="totalCount > 10">
        <el-pagination layout="prev, pager, next" :total="totalCount" :current-page.sync="currentPage"
                        :page-size="10" @current-change="onChangePage"></el-pagination>
      </div>
    </div>

    <!--侧滑-->
    <component :is="currentRightPanel" :items="rightPanelData" @onClosePanel="onClosePanel" @callback="getSshKeys"></component>
  </div>
</template>

<script>
  import STORE_CONST from '../../store/consts'
  import AddSshkey from './model/add-sshkey'
  export default{
    data () {
      return {
        loading: false,
        sshKeyList: [],
        totalCount: 0,
        currentPage: 1,
        currentRightPanel: null,
        rightPanelData: null
      }
    },
    computed: {
      // attribute text
      attrText () {
        return this.getAttrText()
      }
    },
    created () {
      this.getSshKeys()
    },
    methods: {
      // 提取翻译文本
      getAttrText () {
        return {
          name: this.$gettext('Name'),
          latestVerifiTiem: this.$gettext('The Time Of Latest Verification'),
          addTime: this.$gettext('Add Time'),
          action: this.$gettext('Action')
        }
      },
      // 获取sshkey列表
      getSshKeys (page) {
        this.currentPage = page || 1
        this.loading = true
        let params = {
          page: page || 1,
          q: {
            order_by: [{'field': 'create_time', 'direction': 'desc'}]
          }
        }
        this.$store.dispatch(STORE_CONST.SSHKEY.GET, {params: params}).then((res) => {
          this.loading = false
          this.sshKeyList = this.$store.getters.sshKey
          this.totalCount = res.num_results
        })
      },
      // 分页
      onChangePage (page) {
        this.getSshKeys(page)
      },
      // 删除 sshkey
      delSshkey (id) {
        this.$confirm(this.$gettext('Confirm to delete the SSH KEY?'), this.$gettext('prompt'), {
          confirmButtonText: this.$gettext('OK'),
          cancelButtonText: this.$gettext('Cancel'),
          type: 'warning'
        }).then(() => {
          this.$store.dispatch(STORE_CONST.SSHKEY.DEL, id).then(() => {
            this.getSshKeys()
            this.$notify({
              type: 'success',
              message: this.$gettext('successfully deleted!')
            })
          })
        }).catch(() => {
        })
      },
      // 显示添加sshkey
      onShowAdd () {
        const time = !this.currentRightPanel || this.currentRightPanel.name === 'AddSshkey' ? 0 : 300
        this.currentRightPanel = AddSshkey
        this.$nextTick(() => {
          setTimeout(() => {
            this.rightPanelData = {
              'title': {
                label: this.$gettext('Name'),
                val: '',
                rule: [
                  {required: true, message: this.$gettext('Please input the name'), trigger: 'blur'},
                  {max: 20, message: this.$gettext('length is within 20 characters'), trigger: 'change'}
                ]
              },
              'pubkey': {
                label: 'Key',
                val: '',
                rule: {required: true, message: this.$gettext('Please input the sshkey'), trigger: 'change'},
                type: 'textarea',
                options: {
                  autosize: true,
                  resize: '300'
                }
              }
            }
          }, time)
        })
      },
      // 关闭侧滑
      onClosePanel () {
        this.rightPanelData = null
      },
      // table row color
      tableRowClassName (row, index) {
        if (index % 2 === 0) {
          return 'info-row'
        }
        return ''
      }
    },
    components: {
      AddSshkey
    }
  }
</script>

<style lang='scss' rel="stylesheet/scss">
  @import "../../assets/css/variable";

  .ssh-key {
    .content {
      padding: 15px;
      .add-ssk {
        height: 40px;
        line-height: 40px;
        padding-left: 15px;
        background-color: #fff;
        border: 1px solid $border-color;
        border-bottom: none;
        a {
          color: $textColor;
          .el-icon-plus {
            font-weight: 700;
            font-size: 12px;
            margin-right: 4px;
          }
          &:hover {
            color: $mainColor;
            text-decoration: none;
          }
        }
      }
    }
    .detail-wrapper {
      height: 100%;
      padding: 60px 20px 0px;
      .el-form-item {
        .el-form-item__label {
          &:before {
            content: '';
          }
        }
        .el-form-item__content {
          .el-textarea {
            height: 300px;
            .el-textarea__inner {
              height: 100%;
            }
          }
        }
        .detail-name {
          display: inline-block;
          width: 40%;
          text-align: right;
        }
        &:first-child {
          margin-top: 0;
        }
        p {
          margin-bottom: 0;
          &.m-top {
            margin-top: 10px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// sshKey.vue?30ef3aaa